import { render } from "./Octicon.vue?vue&type=template&id=b6005626"
import script from "./Octicon.vue?vue&type=script&lang=js"
export * from "./Octicon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/james/Desktop/VueJS/ingredient-swap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__